var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "step-indicator-container" }, [
    _c("p", { staticClass: "mb-2" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__("Etape %(currentStep)s sur %(nbStep)s", {
              currentStep: _vm.currentStepNumber,
              nbStep: _vm.nbStep
            })
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "m-0 flex-level" },
      _vm._l(_vm.nbStep, function(index) {
        return _c("li", {
          key: index,
          staticClass: "step-indicator",
          class: { active: index <= _vm.currentStepNumber }
        })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }